export const environment = {
  production: false,
  api_url: 'https://lime-whale-287732.hostingersite.com/api',
};
